/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_New_Criteria_TitleInputs */

const en_jobs_new_criteria_title = /** @type {(inputs: Jobs_New_Criteria_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New Search Criteria`)
};

const de_jobs_new_criteria_title = /** @type {(inputs: Jobs_New_Criteria_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neues Suchkriterium`)
};

const fr_jobs_new_criteria_title = /** @type {(inputs: Jobs_New_Criteria_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nouveau critère de recherche`)
};

const es_jobs_new_criteria_title = /** @type {(inputs: Jobs_New_Criteria_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuevo criterio de búsqueda`)
};

const it_jobs_new_criteria_title = /** @type {(inputs: Jobs_New_Criteria_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuovo criterio di ricerca`)
};

const nl_jobs_new_criteria_title = /** @type {(inputs: Jobs_New_Criteria_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nieuw zoekcriterium`)
};

const pl_jobs_new_criteria_title = /** @type {(inputs: Jobs_New_Criteria_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nowe kryterium wyszukiwania`)
};

const fi_jobs_new_criteria_title = /** @type {(inputs: Jobs_New_Criteria_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uusi hakukriteeri`)
};

const da_jobs_new_criteria_title = /** @type {(inputs: Jobs_New_Criteria_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nyt søgekriterium`)
};

const sv_jobs_new_criteria_title = /** @type {(inputs: Jobs_New_Criteria_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nytt sökkriterium`)
};

/**
* | output |
* | --- |
* | "New Search Criteria" |
*
* @param {Jobs_New_Criteria_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const jobs_new_criteria_title = /** @type {((inputs?: Jobs_New_Criteria_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_New_Criteria_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_jobs_new_criteria_title(inputs)
	if (locale === "fr") return fr_jobs_new_criteria_title(inputs)
	if (locale === "es") return es_jobs_new_criteria_title(inputs)
	if (locale === "it") return it_jobs_new_criteria_title(inputs)
	if (locale === "nl") return nl_jobs_new_criteria_title(inputs)
	if (locale === "pl") return pl_jobs_new_criteria_title(inputs)
	if (locale === "fi") return fi_jobs_new_criteria_title(inputs)
	if (locale === "da") return da_jobs_new_criteria_title(inputs)
	if (locale === "sv") return sv_jobs_new_criteria_title(inputs)
	return en_jobs_new_criteria_title(inputs)
});